import { useContext } from "react";
import { ViewerContext, ViewerContextProps } from "./viewer-context-props.ts";

export const useViewerContext = (): ViewerContextProps => {
    const context = useContext(ViewerContext);
    if (!context) {
        throw new Error("useViewerContext must be used within a ViewerContextProvider");
    }
    return context;
};

export default useViewerContext;
